import { MapConfig } from '@kinetic-ui/data-layer';
import { Point } from '@turf/helpers';

export type ViewStateMapConfig = MapConfig & {
  geometry: Point;
  zoom: number;
};

export const isViewStateMapConfig = (config?: MapConfig | null): config is ViewStateMapConfig => {
  return config?.geometry?.type === 'Point';
};
